import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';

import {Client, User, IClient, Contact} from '@nxt/model-core';
// @ts-ignore
import {environment} from '@env/environment';

@Injectable()
export class ClientService {
    signedOut: Observable<any>;
    u$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
    c$: BehaviorSubject<IClient> = new BehaviorSubject<IClient>(environment.default_client);
    client$: BehaviorSubject<Client> = new BehaviorSubject<Client>(undefined);
    clients$: BehaviorSubject<Client[]|null|undefined> = new BehaviorSubject<Client[]|null|undefined>(undefined);
    terms$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
    user: User;
    contact: Contact;

    constructor(
        private http: HttpClient
    ) {
    }

    get client_id(): string {
        return this.c$.getValue()?.id;
    }

    get name_key(): string {
        return this.c$.getValue()?.name_key;
    }

    async callAPI(path: string, method: 'get' | 'post' | 'delete', data?: any, token?: any): Promise<any> {

        token = token || await this.u$.getValue()?.getIdToken() || '';
        const reqOpts: any = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                client: this.c$.getValue().id,
                token: token
            })
        };

        switch (method) {
            case 'delete':
                return this.http.delete(`${environment.fnUrl||''}${path}`, reqOpts).toPromise();
            case 'post':
                return this.http.post(`${environment.fnUrl||''}${path}`, data, reqOpts).toPromise();
            case 'get':
                return this.http.get(`${environment.fnUrl||''}${path}`, reqOpts).toPromise();
        }
    }

    async *streamAPI(path: string, method: 'get' | 'post', data?: any, token?: any): AsyncGenerator<any> {
        try {
            token = token || await this.u$.getValue()?.getIdToken() || '';
            const clientId = this.c$.getValue()?.id;

            const headers: any = {
                'Content-Type': 'application/json',
                'client': clientId,
                'token': token
            };

            const fetchOptions: RequestInit = {
                method: method.toUpperCase(),
                headers: headers
            };

            if (method === 'post' && data) {
                fetchOptions.body = JSON.stringify(data);
            }

            const response = await fetch(`/api${path}`, fetchOptions);

            if (!response.ok) {
                let errorMessage = `HTTP error! status: ${response.status}`;
                try {
                    const errorBody = await response.text();
                    console.error('Error response body:', errorBody);
                    const errorJson = JSON.parse(errorBody);
                    errorMessage = errorJson.error || errorMessage;
                } catch (e) {
                    console.debug('Could not parse error response as JSON:', e);
                }
                throw new Error(errorMessage);
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            try {
                while (true) {
                    const { done, value } = await reader.read();

                    if (done) {
                        console.log('Stream finished');
                        break;
                    }

                    buffer += decoder.decode(value, { stream: true });

                    const lines = buffer.split('\n\n');
                    buffer = lines.pop() || '';

                    for (const line of lines) {
                        if (line.startsWith('data: ')) {
                            try {
                                const data = JSON.parse(line.slice(6));
                                yield data;
                            } catch (parseError) {
                                console.error('Error parsing SSE data:', parseError, line);
                            }
                        }
                    }
                }
            } finally {
                reader.releaseLock();
            }
        } catch (error) {
            console.error('streamAPI error:', error);
            throw error;
        }
    }
}


